(function(){
  'use strict';
  angular.module("irricrops")
    //http://stackoverflow.com/questions/24080018/download-file-from-a-asp-net-web-api-method-using-angularjs
    .directive('estanteria', [function () {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'shared/estanteria/estanteriaButton.tmpl.html',
            scope:{
              disabled:"=disabled",
            },
            controllerAs:"d",
            controller: ['$scope', '$element', '$attrs', '$timeout', '$http', '$mdDialog','urls',
              function ($scope, $element, $attrs,  $timeout, $http, $mdDialog, urls) {

                var vm = this;


                var DialogController = ['$scope', '$mdDialog', '$mdToast', 'parentScope', '$stateParams','CONSTANTES','temporadaFac',
                  function($scope, $mdDialog, $mdToast, parentScope, $stateParams, CONSTANTES, temporadaFac) {

                    var vm                = this;
                    vm.loading            = true;
                    vm.variables          = [];
                    vm.cuarteles          = [];
                    vm.temporadas         = [];
                    vm.temporadaSelected  = null;
                    vm.vinedo_id          = $stateParams.id;
                    vm.tiposDato          = null;
                    vm.tiposDatoTemporada = null;
                    vm.tiposDatoGlobales  = null;





                    temporadaFac.getTemporadas().then(function(res) {
                      vm.temporadas        = res.data.data;
                      vm.temporadaSelected = temporadaFac.getActiva();
                      return getDataEstanteria();
                    });


                    vm.changeTemporadaSelected = function(){
                      vm.loading = true;
                      return getDataEstanteria();
                    }




                    function getDataEstanteria(){
                      vm.loading = true;
                      return getVariablesVinedo(vm.vinedo_id, vm.temporadaSelected)
                        .then(function(data){
                          console.log("in test");
                          console.dir(data);

                          vm.tiposDato          = parseTipoDato(data.data.tipos_dato);
                          vm.tiposDatoTemporada = _.filter(vm.tiposDato, function(t){ return t.porTemporada})
                          vm.tiposDatoGlobales  = _.filter(vm.tiposDato, function(t){ return !t.porTemporada})

                          vm.cuarteles          = _.map(data.data.cuarteles, function(cuartel){
                            cuartel.variables_edit = _.keyBy(_.map(vm.tiposDato, function(tiposDato){
                              var v = _.clone(_.find(cuartel.variables, {tipo_dato_id: tiposDato.id}));
                              if(v == null){
                                //crear dato
                                v = {
                                  tipo_dato_id: tiposDato.id,
                                  cantidad: "",
                                  id: null,
                                }

                              }
                              return v;
                            }), "tipo_dato_id");
                            return cuartel;
                          }); //guardado como original, datos seria el editable

                          vm.loading = false;
                          //vm.variables = parseVariables(data.data.ultimosDatos);
                          //vm.loading = false;
                          //return data; <<---- este retorna hasta afuera de todas las promesas
                        });

                    }


                  function getVariablesVinedo(vinedo_id){
                    return $http.get(urls.BASE+"/vinedo/variables?vinedo_id="+vinedo_id+"&periodo="+vm.temporadaSelected.periodo);
                  };

                  //function getCuarteles(cuartel){
                    //return $http.get(urls.BASE+"/vinedo/cuarteles?vinedo_id=" +vm.vinedo_id);
                  //};










                    //vm.variables 
//                    function parseVariables(ultimosDatos){
//                      return _.map(vm.tiposDato, function(v){
//                        v.dataCuartel = ultimosDatos.find(function(dato){
//                          return v.id == dato.tipo_dato_id
//                        });
//
//                        v.value = null;
//                        if(v.dataCuartel && v.dataCuartel.cantidad){
//                          v.value = v.dataCuartel.cantidad; //separa variable editable de la original
//                          //si es un dato de tipo numerico, lo convierte en Float
//                          if(['Float', 'Integer'].indexOf(v.type) > -1){
//                            v.value = parseFloat(v.value);
//                          }
//                        }
//                        return v;
//                      });
//                    }

                    //convierte el tipo de dato en uno compatible con inputs
                    function parseTipoDato(tiposDato){
                        return _.map(tiposDato, function(v){

                        switch(v.type){
                          case 'Float':
                            //v.typeInput = "float";
                            //break;
                          case 'Integer':
                            v.typeInput = "number";
                            break;
                          case 'String':
                          default:
                            v.typeInput = "text";
                        }
                        return v;
                      });
                    }




                    vm.save = function(){

                      _.forEach(vm.cuarteles, function(cuartel){
                        var saveData = _.reduce(cuartel.variables_edit, function(acum, v){
                          var originalVar = _.find(cuartel.variables, {tipo_dato_id: v.tipo_dato_id});

                          //TODO verificar si esto se cumple con tados float
                          if((originalVar ==  undefined && v.cantidad != "") || (originalVar && originalVar.cantidad != v.cantidad)){
                            acum.push(v);
                          }

                          return acum;
                        }, []);

                        var params = {
                          cuartel_id : cuartel.cuartel_id,
                          fecha      : moment().format("YYYY-MM-DD"),
                          variables  : _.map(saveData, function(s){ 
                            var dataToSave = {
                              id    : s.tipo_dato_id,
                              value : s.cantidad
                            }
                            var tipoDato = _.find(vm.tiposDato, {id:s.tipo_dato_id});
                            if(tipoDato && tipoDato.porTemporada){
                              dataToSave.periodo = vm.temporadaSelected.periodo;
                            }
                            return dataToSave;
                          })
                        };


                        if(params.variables.length > 0){
                          var p = $http.post(urls.BASE+"/cuartel/variables", params)
                        }
                      });

                    }





                  vm.hide = function() {
                    $mdDialog.hide();
                  };


                  vm.cancel = function() {
                    $mdDialog.cancel();
                  };


                }];





                vm.showDialog = function() {

                      $mdDialog.show({
                        controller          : DialogController,
                        controllerAs        : "ctrl",
                        templateUrl         : 'shared/estanteria/estanteriaDialog.tmpl.html',
                        parent              : angular.element(document.body),
                        clickOutsideToClose : true,
                        locals              : {
                          parentScope : $scope,
                        }
                      })
                      .then(function(answer) {
                        // $scope.status = 'You said the information was "' + answer + '".';
                      }, function() {
                        // $scope.status = 'You cancelled the dialog.';
                      });
                }


              }]
        };
    }]);
})();
